import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Text from '../../shared/Text';
import LogoIcon from './logo-icon/LogoIcon';
import { FORGOT_PASSWORD_INDEX } from '../constants/routes';
import { LOGIN_SUPPORT_URL_INCYDR } from '../constants/urls';
import { Box, Link, Paper, Typography } from '@mui/material';

export interface LoginWrapperProps {
  isForgotPasswordVisible: boolean;
}

export const ForgotPasswordLink: React.FC = () => (
  <Typography variant="caption">
    <Link component={RouterLink} data-test="forgot-pw-link" to={FORGOT_PASSWORD_INDEX}>
      {Text.get('login_forgot_password')}
    </Link>
  </Typography>
);

const LoginWrapper: React.FC<LoginWrapperProps> = (props) => {
  const { isForgotPasswordVisible, children, ...rest } = props;

  return (
    <Box minWidth={430} mt="10%" mx="auto" width="min-content">
      <Paper elevation={1}>
        <Box pb={4} pt={5}>
          <Box textAlign="center">
            <LogoIcon />
          </Box>
          <div>
            {Array.isArray(children) ? children.map((child) => React.cloneElement(child, rest)) : children}
          </div>
        </Box>
      </Paper>
      <Box display="flex" justifyContent="space-between" my={2}>
        <Typography variant="caption">
          {Text.get('login_support_need_help')}&nbsp;
          <Link
            href={LOGIN_SUPPORT_URL_INCYDR}
            target="_blank"
            rel="noopener noreferrer"
            data-test="login-wrapper-support-link"
          >
            {Text.get('login_support_learn_more')}
          </Link>
        </Typography>
        {isForgotPasswordVisible && <ForgotPasswordLink />}
      </Box>
    </Box>
  );
};

export default LoginWrapper;
